import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {AddItemButton} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-button';
import {GA4EventName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import type {AddItemOptionsProps} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';
import {ADD_ITEM_BAR_POPUP_OFFSET, ADD_ITEM_BAR_TOP_OFFSET} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';
import {RecordDropdownList} from '@Components/poster-editor/components/poster-add-item-bar/components/record-dropdown-list/record-dropdown-list';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {updateRecordOptionsOpenState} from '@Components/poster-editor/poster-editor-reducer';

export function RecordDropdownOptions({popupClassName = '', arrowClasses = '', isHidden = false}: AddItemOptionsProps): ReactElement<any> | null {
  const [isOpened, setIsOpened] = useState(false);
  const triggerOpenRecordOptions = useAppSelector((state) => {
    return state.posterEditor.triggerOpenRecordOptions;
  });
  const dispatch = useAppDispatch();

  const openRecordOptions = (): void => {
    if (!triggerOpenRecordOptions) {
      setIsOpened(false);
      return;
    }
    setIsOpened(true);
  };

  useEffect(() => {
    openRecordOptions();
  }, [triggerOpenRecordOptions]);

  if (isHidden) {
    return null;
  }

  const getRecordOptions = (): ReactElement<any> => {
    return <RecordDropdownList />;
  };

  return (
    <Dropdown
      open={isOpened}
      className="js-toolbar-record"
      id="toolbar-record"
      key="toolbar-record"
      alignment={ALIGNMENT_TYPE.RIGHT_END}
      selector={<AddItemButton id="toolbar-record-media" isSelected={isOpened} text={window.i18next.t('pmwjs_record')} icon="icon-radio-button-checked" />}
      popup={getRecordOptions()}
      popUpHasCustomHeight
      maxHeight={500}
      position={DROPDOWN_POSITION.FIXED}
      popupOffset={ADD_ITEM_BAR_POPUP_OFFSET}
      topOffset={ADD_ITEM_BAR_TOP_OFFSET}
      popUpHasCustomWidth
      useDefaultArrow
      usePortal
      popupClassName={popupClassName}
      arrowClasses={arrowClasses}
      onOpen={(): void => {
        if (!isOpened) {
          trackPosterBuilderGA4Events(GA4EventName.RECORD_MENU_OPEN);
          setIsOpened(true);
        }
      }}
      onClose={(): void => {
        if (isOpened) {
          setIsOpened(false);
          dispatch(updateRecordOptionsOpenState(false));
        }
      }}
    />
  );
}
